<ng-content select="[actionBar]"></ng-content>
<basin-navmenu
  *ngIf="!hideNavbar"
  [dropdownMenuSelector]="dropdownMenuSelector"
  (dockNavmenu)="dockMenu()"
  (unDockNavmenu)="unDockNavmenu()"
  (stantecLensClick)="stantecLensClicked($event)"
  (logoClick)="logoClicked($event)"
  (homeLinkClick)="homeLinkClicked($event)"
  [dropdownMenuItems]="dropdownMenuItems"
  [footerMenuItems]="footerMenuItems"
  [menuThemeColor]="menuThemeColor"
  [stantecLensClickable]="stantecLensClickable"
  [logo]="logo"
  [logoClickable]="logoClickable"
  [homeLink]="homeLink"
  [homeLinkClickable]="homeLinkClickable"
  [homeLinkText]="homeLinkText"
  [currentPageTitle]="currentPageTitle"
  [selectedDropdownMenuItem]="selectedDropdownMenuItem"
  [navItems]="navItems"
  [displayHeaderIcon]="displayHeaderIcon"
  [showProfile]="showProfile"
  [userProfile]="userProfile"
  [profileMenuItems]="profileMenuItems"
  [ellipsesMenu]="ellipsesMenu"
  [ellipsesMenuItems]="ellipsesMenuItems"
  [headerMenuIcon]="headerMenuIcon"
  [headerMenuItems]="headerMenuItems"
></basin-navmenu>
<section
  [class.docked]="menuDocked && !hideNavbar"
  [ngClass]="[hideNavbar ? 'content-full' : 'content', 'content-navmenu']"
>
  <ng-content select="[content]"></ng-content>
</section>
